var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.2,
    width: 19.6,
    height: 19.6,
    rx: 2.8,
    fill: "#222222"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.2,
    width: 19.6,
    height: 19.6,
    rx: 2.8,
    stroke: "white",
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70105 9.95773C6.68134 9.82964 6.66655 9.70156 6.66655 9.56813L6.66655 6.3328C6.66655 5.14267 7.56826 4.16602 8.66707 4.16602H10.5C11.5989 4.16602 12.5006 5.14267 12.5006 6.3328V8.79128V11.2498H11.6678V6.42887C11.6678 5.6817 11.1012 5.06795 10.4114 5.06795H8.75576C8.06593 5.06795 7.49928 5.6817 7.49928 6.42887V9.57881C7.63725 9.54679 7.78507 9.53078 7.93782 9.53611C9.13024 9.55212 9.59834 10.3954 9.59834 10.3954C9.59834 10.3954 10.0812 9.52544 11.2737 9.53611C12.4661 9.55212 13.3431 10.6889 13.3333 11.6922C13.3234 12.7009 13.1707 13.416 11.4264 14.9584C10.9583 15.3747 10.4705 15.759 9.96297 16.1165C9.70674 16.298 9.37168 16.2926 9.11546 16.1059C8.61287 15.7376 8.13491 15.3427 7.67666 14.9157C5.96194 13.336 5.82397 12.6155 5.83382 11.6068C5.83875 10.9984 6.17382 10.358 6.70105 9.95773Z",
    fill: "#A6F9FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.42940866488738c1a4339721976b1524.svg";
export { ForwardRef as ReactComponent };